<div class="overview">
  <div class="overview__main">
    <div class="overview__header">
      <div class="overview__name-review">
        <h1 class="overview__header-text">
          {{ aviationEvent.title }}
          <mat-icon (click)="openEditTitleDialog()" *ngIf="editModeSet" class="edit-icon">edit</mat-icon>
        </h1>
        <p class="event__content">Start Date: {{ eventStartString }}</p>
        <p class="event__content">End Date: {{ eventEndString }}</p>
      </div>
      <app-event-favorite-icon [eventId]="aviationEvent.eventId"></app-event-favorite-icon>
    </div>
  </div>
  <!-- <div *ngIf="showMap || editModeSet" class="overview__chart-container">
    <div class="overview__chart-wrapper">
      <agm-map #map class="overview__chart" [zoom]="this.isFlyingClub ? 15 : 17" [usePanning]="true"
               [mapTypeControl]="true" [fullscreenControl]="true"
               [mapTypeId]="this.isFlyingClub ? 'satellite' : 'roadmap'"
               [mapTypeControlOptions]="{ position: 6, mapTypeIds: [ 'roadmap', 'satellite' ]}" >
        <agm-marker *ngIf="latlon" [latitude]="latlon.lat"
                    [longitude]="latlon.lon"
                    [markerDraggable]="editModeSet && !isAmbassador" (dragEnd)="pinDropped($event)"></agm-marker>
      </agm-map>
      <div class="overview__chart-legend">
        <div *ngIf="latlonApprox">
          Location is approximate based on street address. This business has not yet given AOPA its exact location.
        </div>
        <ng-container *ngIf="!editModeSet; else editModeDesc">
          <div *ngIf="business.locationDesc">
            Location: {{business.locationDesc}}
          </div>
        </ng-container>

      </div>
    </div>
  </div> -->
</div>
